module.exports = __webpack_public_path__ + "static/media/chrome-manage-creds.35458475.png";